import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AccountService } from 'src/app/account/services/account.service';
import { AlertController } from 'src/app/shared/components/alert/services/alert-controller.service';
import { SplashController } from 'src/app/shared/components/splash/services/splash-controller.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  /**
   *
   * @param authService Service to use a CRUD of routes POST/GET/PUT/DELETE
   */
  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private alertController: AlertController,
    private splashController: SplashController,
    private router: Router
  ) {}

  /**
   * method that checks if the route can be activated
   */
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.guardHandler();
  }
  /**
   * method that checks if the route can be loaded
   */
  canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.guardHandler();
  }

  /**
   * method that checks if there´s an existing token
   */
  guardHandler() {
    if (this.accountService.account) {
      if (this.accountService.account.status === 'pending') {
        this.showInactiveAlert();
      }
      if (localStorage.getItem('token') && localStorage.getItem('account_id') && localStorage.getItem('user_id')) {
        return true;
      } else {
        this.authService.logout();
        return false;
      }
    }
    if (this.router.url !== '/login' && this.router.url !== '/sign-up') {
      this.splashController.showSplashScreen();
    }
    return this.accountService.getAccount().pipe(
      catchError((error: any) => {
        if (this.router.url !== '/login' && this.router.url !== '/sign-up') {
          this.splashController.hiddeSplashScreen();
        }
        return of(error);
      }),
      map((account: any) => {
        this.accountService.account = account;
        if (account.status === 'pending') {
          this.showInactiveAlert();
        }
        if (this.router.url !== '/login' && this.router.url !== '/sign-up') {
          this.splashController.hiddeSplashScreen();
        }
        if (localStorage.getItem('token') && localStorage.getItem('account_id') && localStorage.getItem('user_id')) {
          return true;
        } else {
          this.authService.logout();
          return false;
        }
      })
    );
  }

  /**
   * shows alerts that tells account is inactive
   */
  showInactiveAlert() {
    this.alertController.handleError({
      title: 'Welcome!',
      msg: 'Your account is pending approval. <p>You’ll get an email confirmation when our team verifies your account.</p>',
      iconColor: 'primary-opacity',
      iconName: 'bx bxs-user-pin',
      buttons: [
        {
          buttonText: 'OK',
          buttonColor: 'primary',
          buttonHandler: () => {
            this.authService.logout();
            this.alertController.hideAlert();
          },
        },
      ],
    });
  }
}
